<template lang="pug">
    div.video-editor-control
        tabs-control.video-editor-control__tabs(v-model="activeTab" :tabs="tabs")
            template(v-slot:content-crop)
                video-editor-crop-control(:video="video" :isActive="activeTab === 'crop'" v-model="editData.crop" ref="crop")
            template(v-slot:content-trim)
                video-editor-trim-control(:video="video" :isActive="activeTab === 'trim'"  v-model="editData.trim" ref="trim")
</template>

<script>
export default {
    name: 'video-editor-control',
    props: {
        video: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            activeTab: null,
            editData: {
              trim: null,
              crop: null,
            }
        }
    },
    computed: {
        tabs() {
            return [
                { name: 'crop', label: 'Crop', iconId: 'shield-exclamation'},
                { name: 'trim', label: 'Trim', iconId: 'scissors' },
            ]
        },
    },
    watch: {
        activeTab(val) {
            const { name, label } = this.tabs.find(t => t.name === val)
            this.$emit('changeTab', {
                name,
                label,
            })
        },
    },
    methods: {
        async apply() {
            this.$emit('change', this.video, this.editData)
        },
    }
}
</script>
